export function hideLoader() {
  const elem = document.getElementById('site-loader');
  if (elem) {
    elem.style.display = 'none';
  }
}
